import {Box} from '@customink/pigment-react';
import React from 'react';

export default function OutOfStockOverlay() {
  return (
    <Box
      sx={{
        alignItems: 'center',
        backgroundColor: 'rgba(255,255,255,0.5)',
        borderRadius: '0.5rem',
        bottom: 0,
        display: 'flex',
        height: '100%',
        justifyContent: 'center',
        left: 0,
        pointerEvents: 'none',
        position: 'absolute',
        right: 0,
        top: 0,
        width: '100%',
        zIndex: 100
      }}
    />
  );
}
